export default "__VITE_ASSET__2FFML_UU__"